const D3Node = require('d3-node');
const R = require('ramda');

const drawPyram = ({ colorScheme, cubieSize, spacing, state }) => {
  const color = getColor(colorScheme);

  const d3n = new D3Node();

  const height = Math.sin(Math.PI / 3) * cubieSize;

  const points = getPoints(cubieSize, height, spacing);

  const svg = d3n
    .createSVG(6 * cubieSize + 4 * spacing, 6 * height + 3 * spacing)
    .attr('style', 'stroke-linejoin:round;')
    .append('g');

  R.addIndex(R.forEach)(
    (cubie, index) =>
      svg
        .append('polygon')
        .attr('points', points(index))
        .attr('fill', color(cubie))
        .attr('stroke', 'black'),
    state
  );

  return d3n.svgString();
};

const getColor = ({ L, F, R: Right, D }) =>
  R.cond([
    [R.includes(R.__, ['L', 0]), R.always(L)],
    [R.includes(R.__, ['F', 1]), R.always(F)],
    [R.includes(R.__, ['R', 2]), R.always(Right)],
    [R.T, R.always(D)],
  ]);

const getCubieOrientation = R.cond([
  [
    R.includes(
      R.__,
      R.unnest([R.range(0, 11), R.range(20, 27), R.range(32, 35)])
    ),
    i => Boolean(i & 1),
  ],
  [R.T, i => R.not(i & 1)],
]);

const getColumn = R.cond([
  [R.gt(11), R.identity],
  [R.gt(20), R.subtract(R.__, 10)],
  [R.gt(27), R.subtract(R.__, 18)],
  [R.gt(32), R.subtract(R.__, 24)],
  [R.gt(35), R.subtract(R.__, 28)],
  [R.T, R.always(5)],
]);

const getRow = R.cond([
  [R.gt(11), R.always(0)],
  [R.gt(20), R.always(1)],
  [R.gt(27), R.always(2)],
  [R.gt(32), R.always(3)],
  [R.gt(35), R.always(4)],
  [R.T, R.always(5)],
]);

const getFace = R.cond([
  [R.either(R.gt(5), R.equals(20)), R.always(0)],
  [R.either(R.includes(R.__, R.range(20, 26)), R.equals(5)), R.always(1)],
  [R.either(R.gt(11), R.equals(26)), R.always(2)],
  [R.gt(20), i => Math.floor((i - 11) / 3)],
  [R.T, R.always(1)],
]);

const coordsX = (index, cubieSize, spacing) => {
  const s = spacing * getFace(index);
  const column = getColumn(index);
  return R.map(i => s + ((column + i) * cubieSize) / 2, R.range(0, 3));
};

const coordsY = (index, height, spacing) => {
  const s = spacing * Math.ceil((getRow(index) + 1) / 3);
  const row = getRow(index);
  const a = s + height * row;
  const b = s + height * (row + 1);
  return getCubieOrientation(index) ? [b, a, b] : [a, b, a];
};

const getPoints = R.curry((cubieSize, height, spacing, index) => {
  const [x1, x2, x3] = coordsX(index, cubieSize, spacing);
  const [y1, y2, y3] = coordsY(index, height, spacing);
  return `${x1} ${y1}, ${x2} ${y2}, ${x3} ${y3}`;
});

module.exports = {
  getColor,
  getCubieOrientation,
  getColumn,
  getRow,
  getFace,
  drawPyram,
};
